import React, { useEffect, useMemo, useState } from 'react';
import { resolveAvatarImageSrc } from '../utils/avatarUrl';

interface AvatarImageProps {
    src?: string | null;
    alt: string;
    className?: string;
    fallback: React.ReactNode;
}

const AvatarImage: React.FC<AvatarImageProps> = ({ src, alt, className, fallback }) => {
    const displaySrc = useMemo(() => resolveAvatarImageSrc(src), [src]);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setFailed(false);
    }, [displaySrc]);

    if (!displaySrc || failed) {
        return <>{fallback}</>;
    }

    return (
        <img
            key={displaySrc}
            src={displaySrc}
            alt={alt}
            className={className}
            referrerPolicy="no-referrer"
            onError={() => setFailed(true)}
        />
    );
};

export default AvatarImage;
